<template>
  <div>

    <!-- floating Layer Banners -->
    <floating-layers />
    <!-- //floating Layer Banners -->

    <q-dialog
      v-model="drawerRight"
      :maximized="true"
      transition-show="slide-left"
      transition-hide="slide-right"
    >
      <q-layout class="bg-primary drawerLayout">

        <q-header class="bg-primary">

          <q-toolbar class="q-px-none q-mt-md" style="margin-top:6px;">
            <q-toolbar-title />
            <q-btn flat round dense size="xl" class="q-pa-none" color="white" icon="close" @click="drawerRight=false" style="margin-right:12px;"/>
          </q-toolbar>

          <div class="lang">
            <a href="javascript:" class="on">kr</a>
            <a href="javascript:" @click="gotoSite('EN')">en</a>
            <!--<ul class="drop-con">
              <li><a href="javascript:" @click="gotoSite('EN')">english</a></li>
              <li><a href="javascript:" class="on">korean</a></li>
            </ul>
            <img src="/statics/img/lang_kor.png">-->
          </div>

          <q-toolbar class="q-px-lg q-mt-md no-flex-center" style="margin-top:20px;">
            <div class="hd_search on">
              <div class="sch_box">
                <input type="text" placeholder="Search" :disabled="tagVisible" v-model="keyword" ref="keyword" @keyup.enter="setSearchVisible" @click="setKeywordHide">

              </div>
              <a class="sch_btn" @click="setSearchVisible" onclick="gtag('event', '버튼클릭', {'event_category': 'GNB','event_label': '통합검색',  'non_interaction': true});">검색하기</a>
            </div>
          </q-toolbar>
        </q-header>

        <q-page-container>
          <q-page class="q-px-lg">
            <q-list dark separator class="text-white q-pt-lg">
              <!--<q-item class="">
                <q-btn flat class="text-h5 q-pa-none full-width" align="left" @click="gotoRoute('/news')" onclick="gtag('event', '버튼클릭', {'event_category': 'BURGER','event_label': 'NEWS',});">news</q-btn>
              </q-item>-->
              <!--<q-item class="">
                <q-btn flat class="text-h5 q-pa-none full-width new" align="left" @click="gotoRoute('/live/reporting/34?tab=0&day=1')" onclick="gtag('event', '버튼클릭', {'event_category': 'BURGER','event_label': '2025 WSOP',});">2025 WSOP</q-btn>
              </q-item>-->
              <q-expansion-item class="text-h5 f900" label="news" onclick="gtag('event', '버튼클릭', {'event_category': 'BURGER','event_label': 'NEWS',});">
                <q-item class="text-grey-5 menu_2depth">
                  <q-btn flat class="text-h6 q-py-none full-width" align="left"  @click="gotoRoute('/news')">lastest news</q-btn>
                </q-item>
                <q-item class="text-grey-5 menu_2depth">
                  <q-btn flat class="text-h6 q-py-none full-width" align="left"  @click="gotoRoute('/news/cate/10')">interviews</q-btn>
                </q-item>
              </q-expansion-item>
              <!--<q-item class="">
                <q-btn flat class="text-h5 q-pa-none full-width" align="left" @click="gotoRoute('/events')" onclick="gtag('event', '버튼클릭', {'event_category': 'BURGER','event_label': 'LIVE EVENTS',});">live events</q-btn>
              </q-item>-->
              <q-expansion-item class="text-h5 f900" label="tournaments" onclick="gtag('event', '버튼클릭', {'event_category': 'BURGER','event_label': 'TOURNAMENTS',});">
                <q-item class="text-grey-5 menu_2depth">
                  <q-btn flat class="text-h6 q-py-none full-width" align="left"  @click="gotoRoute('/tournaments')">schedule</q-btn>
                </q-item>
                <q-item class="text-grey-5 menu_2depth">
                  <q-btn flat class="text-h6 q-py-none full-width" align="left"  @click="gotoRoute('/timeline')">timeline</q-btn>
                </q-item>
              </q-expansion-item>
              <!--<q-item class="">
                <q-btn flat class="text-h5 q-pa-none full-width" align="left" @click="gotoRoute('/tournaments')" onclick="gtag('event', '버튼클릭', {'event_category': 'BURGER','event_label': 'TOURNAMENTS',});">tournaments</q-btn>
              </q-item>-->
              <!--<q-item class="">
                <q-btn flat class="text-h5 q-pa-none full-width" align="left" @click="gotoRoute('/gallery')" onclick="gtag('event', '버튼클릭', {'event_category': 'BURGER','event_label': 'GALLERY',});">gallery</q-btn>
              </q-item>-->
              <q-item class="">
                <q-btn flat class="text-h5 q-pa-none full-width" align="left" @click="gotoRoute('/market')" onclick="gtag('event', '버튼클릭', {'event_category': 'BURGER','event_label': 'MARKET',});">infographic</q-btn>
              </q-item>
              <q-item class="">
                <q-btn flat class="text-h5 q-pa-none full-width" align="left" @click="gotoRoute('/training')" onclick="gtag('event', '버튼클릭', {'event_category': 'BURGER','event_label': 'TRAINING',});">training</q-btn>
              </q-item>
              <!--<q-item class="">
                <q-btn flat class="text-h5 q-pa-none full-width" align="left" @click="gotoRoute('/ranking')" onclick="gtag('event', '버튼클릭', {'event_category': 'BURGER','event_label': 'RANKING',});">ranking</q-btn>
              </q-item>-->
              <!--<q-item class="">
                <q-btn flat class="text-h5 q-pa-none full-width" align="left" @click="gotoRoute('/poll')" onclick="gtag('event', '버튼클릭', {'event_category': 'BURGER','event_label': 'POLL',});">poll</q-btn>
              </q-item>-->
              <q-item class="">
                <a class="text-h5" href="https://www.gosty.co.kr/bluffcatch" target="_blank">shop</a>
              </q-item>

              <div class="channel">
                <a href="https://www.instagram.com/bluffandcatch/" target="_blank"><img src="/statics/img/ftr_insta_green.png" title="instagram"></a>
                <a href="https://t.me/bluffcatch_kr" target="_blank"><img src="/statics/img/ftr_tele_green.png" title="telegram"></a>
                <a href="https://www.facebook.com/BluffCatch/" target="_blank"><img src="/statics/img/ftr_fb_green.png" title="facebook"></a>
              </div>

              <!--<div class="tour">
                <p>Poker Tour</p>
                <div class="brand">
                  <a target="_blank" href="https://www.wsop.com"><img src="/statics/img/logo_wsop.png" alt="WSOP" title="WSOP"></a>
                  <a target="_blank" href="https://www.worldpokertour.com"><img src="/statics/img/logo_wpt.png" alt="WPT" title="WPT"></a>
                  <a target="_blank" href="https://www.pokerstarslive.com/ept"><img src="/statics/img/logo_ept.png" alt="EPT" title="EPT"></a>
                  <a target="_blank" href="https://www.theasianpokertour.com"><img src="/statics/img/logo_apt.png" alt="APT" title="APT"></a>
                  <a target="_blank" href="https://asiapokerarena.com"><img src="/statics/img/logo_ctp.png" alt="CTP" title="CTP"></a>
                  <a target="_blank" href="https://useriespoker.com"><img src="/statics/img/logo_usop.png" alt="USOP" title="USOP"></a>
                  <a target="_blank" href="https://triton-series.com"><img src="/statics/img/logo_triton.png" alt="TRITON" title="TRITON"></a>
                  <a target="_blank" href="https://pokerdream-live.com"><img src="/statics/img/logo_pd.png" alt="Poker Dream" title="Poker Dream"></a>
                  <a target="_blank" href="https://www.pokerstarslive.com/appt"><img src="/statics/img/logo_appt.png" alt="APPT" title="APPT"></a>
                  <a target="_blank" href="https://www.acepokerleague.com"><img src="/statics/img/logo_apl.png" alt="APL" title="APL"></a>
                  <a target="_blank" href="https://www.ksop.co.kr"><img src="/statics/img/logo_ksop.png" alt="KSOP" title="KSOP"></a>
                  <a target="_blank" href="https://japanopenpoker.com"><img src="/statics/img/logo_jopt.png" alt="JOPT" title="JOPT"></a>
                  <a target="_blank" href="https://wptevent.jp"><img src="/statics/img/logo_wpt_japan.png" alt="WPT Japan" title="WPT Japan"></a>
                  <a target="_blank" href="https://aspt.world"><img src="/statics/img/logo_aspt.png" alt="ASPT" title="ASPT"></a>
                </div>
              </div>-->

            </q-list>
          </q-page>
        </q-page-container>

      </q-layout>
    </q-dialog>

    <Header @drawer="toggleDrawer()" />

    <!-- contentArea -->
    <section class="contentArea">

      <SubHeader/>

      <transition name="el-fade-in-linear">
        <keep-alive :exclude="excludeComponentNames">
          <router-view></router-view>
        </keep-alive>
      </transition>

      <SubFooter/>

    </section>
    <!-- //contentArea -->

    <Footer/>

  </div>
</template>
<script>
  import DefaultLayout from 'src/pc/layouts/DefaultLayout'
  import Header from '../components/Header'
  import Footer from '../components/Footer'
  import SubHeader from '../components/SubHeader'
  import SubFooter from '../components/SubFooter'
  import FloatingLayers from '../components/FloatingLayers'
  import CommonComputed from 'src/_mixins/CommonComputed'
  import CommonMethods from 'src/_mixins/CommonMethods'
  import {QLayout,QHeader,QDrawer,QScrollArea,QPageContainer,QPage,QToolbar,QToolbarTitle,QDialog,QBtn,QList,QItem,QItemSection,QItemLabel,QExpansionItem,QChip} from 'quasar'
  import { mapGetters } from 'vuex'
  const keyword = ''
  export default {
    // extends: DefaultLayout,
    name: "DefaultLayout",
    components: {
      Header,
      Footer,
      SubHeader,
      SubFooter,
      FloatingLayers,
      QLayout,
      QHeader,
      QDrawer,
      QScrollArea,
      QPageContainer,
      QPage,
      QToolbar,
      QToolbarTitle,
      QDialog,
      QBtn,
      QList,
      QItem,
      QItemSection,
      QItemLabel,
      QExpansionItem,
      QChip
    },
    data () {
      return {
        drawerRight: false,
        keyword: keyword,
        tagVisible: false,
        compareSlot: {
          visible: true,
          open: true
        },
        layerBanner: {
          open: false,
          click: false
        },
        toastBanner: {
          bottom: false
        },
        excludeComponentNames: [

        ]
      }
    },
    watch: {
      'getRoutePath' () {
        this.routeAction()
      }
    },
    created () {
      this.getDisplayDataFromDB({access: this.getAccess, page: this.getCurrentComponentName})
      window.addEventListener('scroll', this.handleScroll);
    },
    mounted() {
      this.routeAction()
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    },
    computed: {
      ...CommonComputed,
      ...mapGetters([
        'getDisplayDataFromDB',
      ]),
      getAccess () {
        return 'mobile'
      },
      getRoutePath () {
        this.keyword = keyword //this.getQueryKeyword
        return this.$route.path + this.$route.params + this.$route.query
      },
      getQueryKeyword () {
        return this.$route.query.keyword ? this.$route.query.keyword : keyword ? keyword : ''
      },
      getDrawerLayoutWidth () {
        return this.drawerRight ? this.getScreenWidth : 0
      },
      getScreenWidth () {
        return screen.width
      },
      getScreenHeight () {
        return screen.height
      },
      getDrawerZIndex () {
        return this.drawerRight ? 10 : 10
      },
      getCookieDomain () {
        const url = window.location.hostname.toString()
        const arr = url.split('.')
        return arr.length === 2 ? `.${url}`
          : arr.length === 3 ? `.${arr[1]}.${arr[2]}`
            : url
      }
    },
    methods: {
      ...CommonMethods,
      routeAction () {
        this.$nextTick(() => {

          setTimeout(() => {
            //TERA LOG - MOBILE 키설정
            window['_LA']=function(){
              (window['_LA'].q=window['_LA'].q||[]).push(arguments)
            }
            // window._nSA('TR8703000270','ngc1.nsm-corp.com','sa-w.js?',location.protocol,document,window._nSA||{},location.hostname);    //테라 실계정 Mobile
            // window._nSA('TR8703005279','ngc1.nsm-corp.com','sa-w.js?',location.protocol,document,window._nSA||{},location.hostname);    //테라 테스트계정 Mobile
          }, 1000)


          //GOOGLE LOG - MOBILE 키설정
          const page_path = window.location.pathname + window.location.search
          window.gtag('config', 'UA-88021356-3', {'page_path': page_path})

          this.getDisplayDataFromDB({access: this.getAccess, page: this.getRouteName})
        })
      },
      toggleDrawer () {
        this.drawerRight = !this.drawerRight
      },
      setSearchVisible () {
        if (this.keyword.trim() !== '') {
          this.$router.push({path: `/article/search/${this.keyword}`})
          this.toggleDrawer()
        }
      },
			setKeywordHide () {
				this.keyword = ''
			},
      gotoRoute (path) {
        if (this.$route.path === path) {
          this.drawerRight = false
        } else {
          this.$router.push({path: path})
        }
      },
      clickKeywordTag (tag) {
        this.tagVisible = false
        this.keyword = tag
        this.setSearchVisible()
      },
      handleScroll (event) {
        if (this.getExistDisplayDataBySectionIdx(6)) {
          if (this.$cookies.isKey("closedToastBanner")) {
            this.toastBanner.bottom = false
          } else {
            setTimeout(function () {
              this.toastBanner.bottom = true
            }.bind(this), 500)
          }
        }
      },
      getExistDisplayDataBySectionIdx (idx) {
        const data = this.$store.getters.getDisplayData
        return data.find(row => row.section.idx === idx)
      },
    }
  }
</script>


<style scoped>
  .contentArea {
    min-width: 100vw !important;
    max-width: 100vw !important;
/*    overflow: hidden !important;*/
    background: #f5f5f5;
  }

  .drawerLayout .hd_search {

    position: relative;
    width: 100%;
  }
  .drawerLayout .hd_search .sch_btn {
    position: absolute;
    right: 0;
    width: 50px;
    height: 50px;
    font-size: 0;
    text-indent: -9999px;
    background: url('/statics/img/hd_search_icon.png') no-repeat center center;
    transition: all 0.2s;
  }
  .drawerLayout .hd_search .sch_btn:hover {
    opacity: 0.9;
  }
  .drawerLayout .hd_search .sch_box {
    position: absolute;
    left: 0px;
    top: 0;
    width: 100%;
    height: 50px;
    background: #222;
  }
  .drawerLayout .hd_search .sch_box input {
    width: 100%;
    height: 50px;
    padding: 0 20px;
    font-size: 18px;
    font-weight: 600;
    font-style: italic;
    color: rgba(255, 255, 255, 0.7);
    border: 0;
  }
	.drawerLayout .hd_search .sch_box input::placeholder {
    font-size: 18px;
  }
  .drawerLayout .hd_search .sch_box input:disabled {
    background: #243745 !important;
  }
  .drawerLayout .hd_search .sch_box input::-webkit-input-placeholder {
    color: #666;
  }
  .drawerLayout .hd_search .sch_box input:-moz-placeholder {
    color: #666;
  }
  .drawerLayout .hd_search .sch_box input::-moz-placeholder {
    color: #666;
  }
  .drawerLayout .hd_search .sch_box input:-ms-input-placeholder {
    color: #666;
  }
  .drawerLayout .hd_search .sch_box .tag {
    position: absolute;
    left: 7px;
    top: 8px;
    background: #243745;
    font-weight: 500;
    cursor: pointer;
  }
  /deep/ .q-chip__icon--remove {
    margin-left: 0.5em !important;
  }
  .drawerLayout .hd_search.on .sch_btn {
    background-image: url('/statics/img/hd_search_icon.png');
  }
  .drawerLayout .hd_search.on .sch_btn:hover {
    background-color: #333;
    opacity: 1;
  }
  .drawerLayout .hd_search.on .sch_box {
    display: block;
  }

  .drawerLayout .no-flex-center {
    align-items: initial !important;
  }
	/deep/ .q-expansion-item__content {
		box-shadow: 0 5px 30px rgba(0,0,0,0.2) inset;
		background: #000;
		width: 100vw !important;
		margin-left: -25px;
    padding-bottom: 10px;
  }
  .drawerLayout .top_line {
    border-top: 1px solid #293d4d;
  }
  .q-list--separator>.q-item-type+.q-item-type {
    border-top: 0px solid #293d4d !important;
  }
  .drawerLayout /deep/ .q-item {
    padding: 13px 10px 13px 0;
  }
	.drawerLayout .q-item.letter {
    padding: 0 15px;
  }
	.drawerLayout .q-item a {
    color: #fff;
    text-transform: uppercase;
  }
	.drawerLayout .q-item a.new:after {
    content: "";
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 100%;
    background: #00ff64;
    position: absolute;
    top: 29%;
    margin-left: 5px;
  }
	.drawerLayout .q-item.payapp {
    border-top: 1px solid #2f2f2f !important;
		padding: 20px 10px 20px 15px !important;
		height: unset !important;
    border-bottom: 1px solid #2f2f2f !important;
  }
	.drawerLayout .q-item.cover {
		border-bottom: 1px solid #2f2f2f !important;
		padding: 10px 10px 20px 15px !important;
		height: unset !important;
  }
  .menu_2depth {
    padding: 6px 15px 6px 40px !important;
    min-height: 38px !important;
  }
  .menu_2depth.first {
    padding-top: 20px !important;
  }
  .menu_2depth.last {
    padding-bottom: 20px !important;
  }
  .drawerLayout .q-btn {
    min-height: unset !important;
  }
  /deep/ .q-btn__wrapper {
    padding: 0;
    min-height: inherit;
  }
  /deep/ .q-btn.new .q-btn__content {
    position: relative;
    display: inline-block;
    text-align: left;
  }
  /deep/ .q-btn.new .q-btn__content:after {
    content: "";
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 100%;
    background: #00ff64;
    position: absolute;
    top: 3%;
    margin-left: 5px;
  }
  /deep/ .q-btn .q-icon {
    color: rgba(255,255,255,0.0);
  }
  /deep/ .q-btn .q-icon:before {
    content: "";
    display: inline-block !important;
    width: 32px;
    height: 1.5px;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 0;
    transform: rotate(45deg);
  }
  /deep/ .q-btn .q-icon:after {
    content: "";
    display: inline-block !important;
    width: 32px;
    height: 1.5px;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 0;
    transform: rotate(-45deg);
  }
	.item-new {
		font-size: 13px !important;
	}
	.item-new span {
		color: #ffa800;
	}
  .text-h5 {
    font-family: 'Roboto Slab' !important;
    font-size: 22px !important;
    font-weight: 800 !important;
    letter-spacing: 0.01em;
    line-height: 1.0em;
    text-transform: capitalize !important;
  }
  .text-h6 {
    font-size: 1.35rem;
    color: #a8abaf;
    text-transform: capitalize;
    letter-spacing: -0.01em;
  }
	.bold {
		color: #fff;
	}
	.bold:after {
		content: "N";
		font-size: 0.7em;
		color: #fff;
		font-weight: 900;
		margin-left: 86px;
		position: absolute;
		background: #ffa800;
		border-radius: 100%;
		width: 16px;
		height: 16px;
		line-height: 16px;
	}
  .q-pt-lg {
    padding-top: 15px;
  }
  .justify-center {
    justify-content: unset !important;
  }

	::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
		color: #aaa;
		opacity: 1; /* Firefox */
		font-size: 11px;
	}
	:-ms-input-placeholder { /* Internet Explorer 10-11 */
		color: #aaa;
		font-size: 11px;
	}
	::-ms-input-placeholder { /* Microsoft Edge */
		color: #aaa;
		font-size: 11px;
	}
  /deep/ .ad_wrap {
    margin: 50px auto;
    text-align: center;
  }
  /deep/ .ad_wrap.mid {
    margin: 0;
    padding: 20px 0;
    text-align: center;
  }
  /deep/ .ad_wrap.mid a {
    padding: 20px 0;
  }
  /deep/ .ad_wrap img {
    width: 250px;
    height: 250px;
  }
  .channel a {
    display: inline-block;
    padding: 25px 15px;
  }
  .channel a:first-child {
    padding-left: 0;
  }
  .channel a img {
    height: 36px;
  }
  .tour {
    margin-top: 10px;
    padding: 35px 0 50px 0;
    border-top: 1px solid rgba(255,255,255,0.2);
    display: none;
  }
  .tour p {
    font-size: 12px;
    font-weight: 800;
    text-transform: uppercase;
    margin-bottom: 12px;
  }
  .tour .brand {
    margin-left: -15px;
  }
  .tour a {
    display: inline-block;
    width: 57px;
    height: 50px;
    padding: 12px;
    text-align: center;
    position: relative;
  }
  .tour a img {
    height: 26px;
    position: absolute;
    left: 50%;
    transform: translate(-50%,0);
  }
  .lang {
    position: absolute;
    top: 30px;
    left: 24px;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    z-index: 10;
  }
  .lang:hover .drop-con {
    display: block;
  }
  .lang a {
    display: inline-block;
    font-size: 14px;
    font-weight: 900;
    color: #888;
    display: inline-flex;
    align-items: center;
    text-transform: uppercase;
    margin-right: 18px;
  }
  .lang a.on {
    color: #fff;
  }
/*
  .lang p:after {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg) translate(0,-20%);
    margin-left: 8px;
    margin-right: 18px;
  }
*/
  .lang .drop-con {
    display: none;
    position: absolute;
    top: 40px;
    background: #1c1c1c;
    padding: 10px 15px;
    line-height: 1.0em;
  }
  .lang .drop-con a {
    font-size: 12px;
    font-weight: 900;
    color: #999;
    text-transform: uppercase;
    display: inline-block;
    padding: 5px 0 5px 15px;
  }
  .lang .drop-con a.on {
    color: #fff;
  }
  .lang .drop-con a.on:before {
    content: "";
    display: inline-block;
    width: 5px;
    height: 8px;
    border: solid #fff;
    border-width: 0 1px 1px 0;
    transform: rotate(45deg) translate(0,-20%);
    position: absolute;
    margin-top: 2px;
    left: 15px;
  }
  .lang .drop-con a:hover {
    color: #00ff64;
  }
  .lang img {
    height: 32px;
  }
</style>
